import React from 'react';
import { useLocation, Link } from 'react-router-dom';

import { mobileUrlsAppendQueryParams } from '../../../../util/helpers';
import SaveIcon from '../../../../components/icons/SaveIcon';
import AppStoreLink from '../../../../components/global/AppStoreLink';
import XIcon from '../../../../components/icons/XIcon';
import PlayStoreLink from '../../../../components/global/PlayStoreLink';
import { getAsset } from '../../../../util/assets';

const WaldogramReferralPlaceholder = () => {
  const location = useLocation();
  const { search } = location;
  const { androidAppUrl, iosAppUrl } = mobileUrlsAppendQueryParams(search);

  return (
    <div className="wrapper-main">
      <div className="waldogram-referral-container">
        <Link to="/app">
          <img
            src={getAsset('/waldo-logo.svg')}
            width="150"
            alt="Waldo"
            className="mb-2"
          />
        </Link>

        <h3>You are one step away from creating your first Waldogram!</h3>

        <p className="mb-2">
          Download the Waldo App on your mobile device to create your first
          Waldogram!
        </p>

        <div className="waldogram-referral-groove">
          <img src={getAsset('/groove.svg')} alt="Waldo Groove" />
        </div>

        <div className="d-flex align-items-center mb-2 justify-content-center">
          <span className="waldogram-referral-dl-icon">
            <SaveIcon color="#fff" size={18} />
          </span>

          <h4 className="text-extra-bold text-primary ml-2 mb-0">
            Don’t have the Waldo App? Download Now
          </h4>
        </div>

        <div className="waldogram-referral-app-icons">
          <AppStoreLink customLink={iosAppUrl} width={120} />
          <PlayStoreLink customLink={androidAppUrl} width={120} />
        </div>

        <div className="text-center mt-3">
          <h3 className="text-extra-bold text-faded">Follow me for updates</h3>

          <div className="waldogram-referral-social-icons">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.facebook.com/waldophotos"
            >
              <img
                alt="Facebook Page"
                src={getAsset('/icon-facebook.png')}
                width={25}
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.instagram.com/waldophotos"
            >
              <img
                alt="Instagram Page"
                src={getAsset('/icon-instagram.png')}
                width={25}
              />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/waldophotos"
            >
              <XIcon size={25} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaldogramReferralPlaceholder;
